exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\ntr.checked[data-v-51c37ef2], tr.checked[data-v-51c37ef2]:hover {\n    background-color: #0094ff !important;\n    color: #fff;\n}\ntable.small-padding td[data-v-51c37ef2], table.small-padding th[data-v-51c37ef2]{\n    padding: 3px 5px;\n}\n", ""]);

// exports
